import { Inject } from '@angular/core';
import { MapGeocoder, MapGeocoderResponse } from '@angular/google-maps';

import { BehaviorSubject, Observable } from 'rxjs';

export class SMapService {
  protected mapLoadedBs = new BehaviorSubject<boolean>(false);
  protected mapLoaded$: Observable<boolean> = this.mapLoadedBs.asObservable();

  protected geocoder: MapGeocoder;

  constructor() {
    this.geocoder = Inject(MapGeocoder);
  }

  loadApi(): Observable<boolean> {
    throw new Error('loadApi() must be overridden');
  }

  getLocation(address: string): Observable<MapGeocoderResponse> {
    return this.geocoder.geocode({ address: address });
  }
}
